import React from 'react';
import { Add, Delete, Edit, LockReset, MarkEmailUnread } from '@mui/icons-material';

import { BaseStatusChip } from '../../Paylinks/components/StatusChip';
import type { PortalUserAuditLogAction } from '../../../store/modules/merchant/types';
import { colorError, colorSuccess, colorWarning, StatusColor } from '../../../util/constants';

const activationEmailColor: StatusColor = { bg: '#EFF8FF', text: '#175CD3' };
const passwordResetEmailColor: StatusColor = { bg: '#F4F3FF', text: '#5925DC' };

const actionUiMap: Record<
  Exclude<PortalUserAuditLogAction, 'sendAccessEmail'>,
  { icon: JSX.Element; color: StatusColor; label: string }
> = {
  create: { icon: <Add />, color: colorSuccess, label: 'Create' },
  update: { icon: <Edit />, color: colorWarning, label: 'Edit' },
  delete: { icon: <Delete />, color: colorError, label: 'Delete' },
};

type Props = {
  action: PortalUserAuditLogAction;
  emailType?: 'activation' | 'passwordReset';
  size?: 'small' | 'medium';
};

export const PortalUserAuditActionChip = ({
  action,
  emailType,
  size = 'small',
}: Props): JSX.Element => {
  const actionUi =
    action === 'sendAccessEmail'
      ? emailType === 'passwordReset'
        ? {
            icon: <LockReset />,
            color: passwordResetEmailColor,
            label: 'Password reset email sent',
          }
        : {
            icon: <MarkEmailUnread />,
            color: activationEmailColor,
            label: 'Sign-up email sent',
          }
      : actionUiMap[action];

  return (
    <BaseStatusChip
      color={actionUi.color}
      icon={actionUi.icon}
      label={actionUi.label}
      size={size}
    />
  );
};
